<app-badge>
  <mat-icon class="material-icons-outlined">upload_file</mat-icon>
  {{ 'data_sources.custom_sources.imports.types.' + datasource.payload.relationships.data_set_usage_custom_configuration.data.attributes.import_type | translate }}
</app-badge>
